import axios from "axios"

import { API_URL } from "../../config/appConfig"

import { ACTION_TYPE_PARENT, ACTION_TYPE_PARENT_STAGE } from "./actions"

const INSTRUMENT_BASE_URL_STAGE = `${API_URL}/api/InstrumentStage`
const INSTRUMENT_BASE_URL = `${API_URL}/api/Instrument`
const INSTRUMENT_BULK_CHANGE_BASE_URL = `${API_URL}/api/InstrumentBulkChange`

export const getDocumentsByApplicationId = (nsm: string, applicationId: string) => {
  return axios.get(`${INSTRUMENT_BASE_URL}/${nsm}/documents/${applicationId}`)
}

export const postInstrumentStage = (payload: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL_STAGE}`, payload)
}

export const getAllStaged = () => {
  return axios.get(`${INSTRUMENT_BASE_URL_STAGE}/all`)
}

export const getInstrumentStageNSM = (nsm: string) => {
  return axios.get(`${INSTRUMENT_BASE_URL_STAGE}/${nsm}`)
}

export const postInstrumentDocumentAssociation = ({ nsm, documentId }: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL_STAGE}/${nsm}/${documentId}`)
}

export const deleteInstrumentDocumentAssociation = (instrumentDocumentId: string) => {
  return axios.delete(`${INSTRUMENT_BASE_URL_STAGE}/${instrumentDocumentId}`)
}

export const postInstrumentListingContact = (payload: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL}/instrumentListingContact`, payload)
}

export const postUpdateInstrumentListingContact = (payload: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL}/updatelistingcontact`, payload)
}

export const postInstrumentPricingContact = (payload: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL}/createpricingrelation`, payload)
}

export const postUpdateInstrumentPricingContact = (payload: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL}/updatepricingorg`, payload)
}

export const deleteInstrumentPricingRelation = (payload: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL}/deleteInstrumentPricingAgentRelation`, payload)
}

export const getInstrumentPaginatedData = (pageIndex: number, pageSize: number, payload: any, params: any, headers: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL}/instrumentlist/${pageIndex}/${pageSize}`, payload, { params, headers })
}

export const getStageInstrumentData = (payload: any, params : any, headers: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL_STAGE}/all`, payload, { params, headers })
}

export const getInstrumentSearch = (payload: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL}/search`, payload)
}

export const getInstrumentsByToken = (token: string, pageNumber: number, headers: any, params: any) => {
  return axios.get(`${INSTRUMENT_BASE_URL}/instrumentlookup/${token}/${pageNumber}`, { headers, params })
}

export const putInstrumentStage = (payload: any) => {
  return axios.put(`${INSTRUMENT_BASE_URL_STAGE}`, payload)
}

export const patchInstrumentStageStatus = (payload: any) => {
  return axios.patch(`${INSTRUMENT_BASE_URL_STAGE}/${payload.status}`, payload)
}

export const getInstrumentById = (id: string) => {
  return axios.get(`${INSTRUMENT_BASE_URL}/instrumentView/${id}`)
}

export const getPricingAgentsByIssuer = (issuerID: number, current: boolean, nsm: string, headers: any) => {
  return axios.get(`${INSTRUMENT_BASE_URL}/instpasbyissuer/${issuerID}/${current}?nsm=${nsm}`,{headers})
}

export const getInstrumentListingContactByIssuer = (issuerID: number, current: boolean, nsm: string) => {
  return axios.get(`${INSTRUMENT_BASE_URL}/instlistingcontactbyissuer/${issuerID}/${current}?nsm=${nsm}`)
}

export const deleteInstrumentListingContactRelation = (payload: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL}/deleteInstrumentListingContactRelation`, payload)
}

export const getAllInstrumentsForBulkChange = (issuerId: number, headers: any) => {
  return axios.get(`${INSTRUMENT_BULK_CHANGE_BASE_URL}/instrumentsforbulk/${issuerId}`, { headers })
}

export const postInstrumentsForBulkChange = (payload: any) => {
  return axios.post(`${INSTRUMENT_BULK_CHANGE_BASE_URL}`, payload)
}

export const postWithdrawInstrumentStage = (nsm: string) => {
  return axios.post(`${INSTRUMENT_BASE_URL_STAGE}/withdrawStage/${nsm}`)
}

export const getInstrumentsByDocId = (documentId: string, assigned: boolean, headers: any) => {
  return axios.get(`${INSTRUMENT_BASE_URL}/instruments/${documentId}/${assigned}`, { headers })
}

export const deleteDocumentForNsm = (documentId: string, nsm: string, applicationId: number) => {
  return axios.delete(`${INSTRUMENT_BASE_URL}/${nsm}/${documentId}`, { params: { applicationId } })
}

export const postDocumentForNsm = (documentId: string, nsm: string, applicationId: number) => {
  return axios.post(`${INSTRUMENT_BASE_URL}/${nsm}/${documentId}`, {}, { params: { applicationId } })
}

export const getListingStats = () => {
  return axios.get(`${INSTRUMENT_BASE_URL_STAGE}/StageStats`)
}

export const postInstrumentStageEffectiveDate = (effectiveDate: string, instrumentStageIds: string[]) => {
  return axios.post(`${INSTRUMENT_BASE_URL_STAGE}/updateEffectiveDate`, instrumentStageIds, { params: { effectiveDate } })
}

export const getSecurityLookUp = (payload: any, headers: any) => {
  return axios.post(`${INSTRUMENT_BASE_URL}/searchdirectory`, payload, { headers });
}

export const postInstrumentStageLock = (nsm: string) => {
  return axios.post(`${INSTRUMENT_BASE_URL_STAGE}/isLock/${nsm}`)
}